import config from "../../../../../../config/config";
import axios from "axios";

const GET_ALL_TOWNSHIPS = config.baseUrl + "township";
const GET_ALL_TOWNSHIPS_GROUPS = config.baseUrl + "township/list/cities";

const GET_ALL_TRAVELS = config.baseUrl + "travel/index/search";
const LOGIN = config.baseUrl + "auth/login";
const REGISTER = config.baseUrl + "auth/registerWithMobile";
const VERIFY_REGISTER = config.baseUrl + "auth/verifyRegister";
const LOGIN_MOBILE = config.baseUrl + "auth/loginWithMobile";
const VERIFY_MOBILE = config.baseUrl + "auth/verifyLogin";
const INSERT_PASSENFER_INFO = config.baseUrl + "ticket/insertPassengerInfo";
const GET_FAV_PASSENGERS = config.baseUrl + "ticket/favoritePassenger";
const Get_Ticket_Status = config.baseUrl + "ticket/getTicketDetails";
const Get_Town_And_Pro = config.baseUrl + "township/list/cities";
const Get_Travel_Stations = config.baseUrl + "travel/detail/getTravelStations";
const Get_Travel_Type = config.baseUrl + "travelType";
const Set_Charter = config.baseUrl + "charter";
const Contact_Us = config.baseUrl + "contact";
const Set_Discount = config.baseUrl + "ticket/getTicketDiscount";
const CANCEL_TICKET = config.baseUrl + "ticket/cancelTicket";

export const getAllTownships = () => {
  return axios.get(GET_ALL_TOWNSHIPS);
};

export const getTicketDiscount = (params, token) => {
  return axios.get(Set_Discount, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
};

export const createContactMessage = (data) => {
  return axios.post(Contact_Us, data);
};

export const getTravelStations = (params) => {
  return axios.get(Get_Travel_Stations, { params });
};

export const getTravelType = () => {
  return axios.get(Get_Travel_Type);
};

export const setCharter = (data) => {
  return axios.post(Set_Charter, data);
};

export const getAllTownshipsGroup = (params) => {
  return axios.get(GET_ALL_TOWNSHIPS_GROUPS, { params });
};

export const getTownAndProvinces = () => {
  return axios.get(Get_Town_And_Pro);
};

export const getAllTravels = (params) => {
  return axios.get(GET_ALL_TRAVELS, { params });
};

export const login = (data) => {
  return axios.post(LOGIN, data);
};

export const SignInWithMobile = (data) => {
  return axios.post(REGISTER, data);
};

export const RegisterWithMobile = (data) => {
  return axios.post(REGISTER, data);
};

export const VerifyRegister = (data) => {
  return axios.post(VERIFY_REGISTER, data);
};

export const loginWithMobile = (data) => {
  return axios.post(LOGIN_MOBILE, data);
};

export const getTicketDetails = (params, token) => {
  return axios.get(Get_Ticket_Status, {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const VerifyLogin = (data) => {
  return axios.post(VERIFY_MOBILE, data);
};

export const insertPassengerInfo = (data, token) => {
  return axios.post(INSERT_PASSENFER_INFO, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getAllFavPassengers = (token) => {
  return axios.get(GET_FAV_PASSENGERS, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const cancelTiket = (ticketId, token) => {
  return axios.post(CANCEL_TICKET, ticketId, {
    headers: { Authorization: `Bearer ${token}` },
  });
};